import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import { C } from '../theme';

const EULA: React.FC = () => {
  return (
    <Box sx={{ pt: '110px', pb: 8, backgroundColor: C.bg, minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, color: C.white }}>
            Uslovi korišćenja
          </Typography>
          <Typography variant="h6" sx={{ color: C.muted, fontWeight: 400 }}>
            End User License Agreement (EULA)
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            backgroundColor: C.surface,
            borderRadius: 4,
            border: `1px solid ${C.line}`,
          }}
        >
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Dobrodošli na Nađi Investitora platformu. Korišćenjem naše aplikacije i usluga, 
            prihvatate sledeće uslove korišćenja.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            1. Prihvatanje uslova
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Pristupanjem i korišćenjem ove platforme, prihvatate da ćete se pridržavati svih 
            navedenih uslova i pravila zajednice. Ako ne prihvatate ove uslove, molimo vas 
            da ne koristite našu platformu.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            2. Sadržaj koji generiše korisnik
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Naša platforma omogućava korisnicima da postavljaju oglase, poruke i drugi sadržaj. 
            Kao korisnik, odgovorni ste za sadržaj koji objavljujete i saglasni ste da:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Nećete postavljati sadržaj koji je uvredljiv, vulgaran, pornografski, klevetnički, 
              ili na bilo koji način neprihvatljiv
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Nećete zlostavljati, uznemiravati ili pretiti drugim korisnicima
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Nećete postavljati lažan ili prevaran sadržaj
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Nećete kršiti autorska prava ili druga prava intelektualne svojine
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Nećete postavljati sadržaj koji promovira nasilje, mržnju ili diskriminaciju
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700, color: C.danger }}>
            3. Nulta tolerancija na neprihvatljiv sadržaj
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontWeight: 500 }}>
            Nađi Investitora ima <strong>NULTU TOLERANCIJU</strong> prema uvredljivom sadržaju 
            i zlostavljanju korisnika. Bilo kakvo kršenje ovih pravila će rezultirati:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Trenutnim uklanjanjem sadržaja
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Suspenzijom ili trajnim blokiranjem korisničkog naloga
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Prijavljivanjem nadležnim organima u slučaju krivičnih dela
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            4. Prijavljivanje neprihvatljivog sadržaja
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Ako naiđete na sadržaj koji krši ove uslove ili je na bilo koji način neprihvatljiv, 
            molimo vas da ga prijavite pomoću opcije "Prijavi" dostupne na svakom oglasu i 
            poruci. Sve prijave se obrađuju u roku od 24 sata.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            5. Blokiranje korisnika
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Imate pravo da blokirate korisnike koji vas uznemiravaju ili čiji sadržaj ne želite 
            da vidite. Kada blokirate korisnika:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Više nećete videti njihove oglase ili poruke
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Oni neće moći da vam šalju poruke
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Naš tim će biti obavešten o blokiranju za dalju evaluaciju
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            6. Moderacija sadržaja
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Zadržavamo pravo da:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Pregledamo i moderišemo sav sadržaj koji korisnici postavljaju
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Uklonimo bilo koji sadržaj koji krši ove uslove
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Suspendujemo ili trajno zabranimo pristup korisnicima koji krše pravila
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Prijavimo nezakonite aktivnosti nadležnim organima
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            7. Vreme odziva
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Obavezujemo se da ćemo delovati na sve prijave neprihvatljivog sadržaja u roku od 
            24 sata. U slučaju ozbiljnih prekršaja (nasilje, pretnje, pornografija), delujemo 
            trenutno i uklanjamo sadržaj odmah po otkrivanju.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            8. Privatnost i bezbednost
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Vaša privatnost je važna za nas. Prikupljamo i obrađujemo vaše lične podatke u 
            skladu sa zakonima o zaštiti podataka. Nikada nećemo deliti vaše lične informacije 
            sa trećim licima bez vaše saglasnosti, osim kada je to neophodno po zakonu.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            9. Odricanje odgovornosti
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Platforma Nađi Investitora služi samo za povezivanje korisnika. Ne garantujemo 
            tačnost, pouzdanost ili kvalitet sadržaja koji korisnici postavljaju. Korisnici 
            su samostalno odgovorni za proveru informacija i sprovođenje transakcija.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            10. Izmene uslova
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Zadržavamo pravo da izmenimo ove uslove korišćenja u bilo kom trenutku. Izmene će 
            biti objavljene na ovoj stranici sa datumom poslednje izmene. Nastavljajući da 
            koristite platformu nakon objave izmena, prihvatate nove uslove.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            11. Dozvola korišćenja
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Platforma vam daje ne-ekskluzivnu, neprenosivu, opozivnu dozvolu za korišćenje 
            aplikacije u skladu sa ovim uslovima.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            12. Ograničenja korišćenja
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Nije vam dozvoljeno da:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Kopirate, modifikujete ili pravite izvedena dela aplikacije
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Vršite reverzni inženjering, dekompilujete ili pokušavate da izvučete izvorni kod
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Distribuirate, dajete u podzakup, iznajmljujete ili na bilo koji način činite 
              aplikaciju dostupnom trećim licima bez odobrenja
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            13. Vlasništvo nad intelektualnom svojinom
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Sva prava intelektualne svojine u i na aplikaciji, uključujući softver, kod i dizajn, 
            ostaju ekskluzivno vlasništvo vlasnika platforme Nađi Investitora.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            14. Raskid ugovora
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Ova dozvola ostaje na snazi dok se ne raskine. Automatski se raskida ako ne 
            poštujete ove uslove ili nakon brisanja vašeg korisničkog naloga. Nakon raskida, 
            morate prestati sa korišćenjem aplikacije.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            15. Odricanje od garancija
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Aplikacija se pruža "kakva jeste" i "kako je dostupna", bez ikakvih garancija. 
            U maksimalnoj meri dozvoljenoj zakonom, vlasnik platforme odriče se svih garancija, 
            bilo eksplicitnih, implicitnih ili zakonskih, uključujući ali ne ograničavajući se na 
            garancije tržišnosti, podobnosti za određenu svrhu i nekršenja prava.
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Ne garantujemo da će aplikacija biti bez grešaka, sigurna, ili neprekidno dostupna. 
            Korišćenje aplikacije je na vaš sopstveni rizik.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            16. Ograničenje odgovornosti
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            U najvećoj meri dozvoljenoj zakonom, Nađi Investitora i njegovi vlasnici, zaposleni 
            i partneri neće biti odgovorni za bilo kakvu direktnu, indirektnu, slučajnu, posebnu 
            ili posledičnu štetu koja proizlazi iz korišćenja ili nemogućnosti korišćenja aplikacije.
          </Typography>

          <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            17. Kontakt
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Ako imate pitanja o ovim uslovima korišćenja, molimo vas da nas kontaktirate:
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Email: info@nadjiinvestitora.com
            </Typography>
            <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Website: www.nadjiinvestitora.com
            </Typography>
          </Box>

          <Box sx={{ mt: 5, pt: 3, borderTop: `1px solid ${C.line}` }}>
            <Typography variant="body2" sx={{ color: C.muted, fontStyle: 'italic' }}>
              Poslednja izmena: 4. januar 2026
            </Typography>
            <Typography variant="body2" sx={{ color: C.muted, fontStyle: 'italic', mt: 1 }}>
              Verzija: 1.0
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default EULA;
